.pie-loading {
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: #fff;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: 9999;
  opacity: 0.4;
}

.pie-loading.fixed {
  position: fixed;
}

.pie-loading:before {
  content: "";
  background-color: rgba(0, 0, 0, 0);
  border: 5px solid rgba(63, 81, 181, 0.9);
  opacity: 0.9;
  border-right: 5px solid rgba(0, 0, 0, 0);
  border-left: 5px solid rgba(0, 0, 0, 0);
  border-radius: 50px;
  box-shadow: 0 0 35px rgba(63, 81, 181, 0.9);
  width: 50px;
  height: 50px;
  -moz-animation: spinPulse 1s infinite ease-in-out;
  -webkit-animation: spinPulse 1s infinite linear;
  margin: -25px 0 0 -25px;
  position: absolute;
  top: 50%;
  left: 50%;
}

.pie-loading:after {
  content: "";
  background-color: rgba(0, 0, 0, 0);
  border: 5px solid rgba(63, 81, 181, 0.9);
  opacity: 0.9;
  border-left: 5px solid rgba(0, 0, 0, 0);
  border-right: 5px solid rgba(0, 0, 0, 0);
  border-radius: 50px;
  box-shadow: 0 0 15px rgba(63, 81, 181, 0.9);
  width: 30px;
  height: 30px;
  -moz-animation: spinoffPulse 1s infinite linear;
  -webkit-animation: spinoffPulse 1s infinite linear;
  margin: -15px 0 0 -15px;
  position: absolute;
  top: 50%;
  left: 50%;
}

@keyframes spinPulse {
  0% {
    transform: rotate(160deg);
    opacity: 0;
    box-shadow: 0 0 1px rgba(63, 81, 181, 0.9);
  }
  50% {
    transform: rotate(145deg);
    opacity: 1;
  }
  100% {
    transform: rotate(-320deg);
    opacity: 0;
  }
}

@keyframes spinoffPulse {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.pie-api-player img {
  max-width: inherit !important;
  max-height: inherit !important;
}

/* These styles are used in the body content of an item -- they also appear in the item body editor. */

.book-title-k5 {
  text-decoration: underline;
}

.book-title {
  font-style: italic;
}

.block-quote {
  font-family: serif;
  margin-left: 20%;
  margin-right: 20%;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 60%;
  border: 1px solid black;
  padding: 2px;
  display: block;
}

.text-block {
  font-family: serif;
  margin-left: 20%;
  margin-right: 20%;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 60%;
  border: 1px solid black;
  padding: 2px;
  display: block;
}

.short-quote {
  font-weight: bold;
}

span.short-quote:before {
  content: open-quote;
}

span.short-quote:after {
  content: close-quote;
}

.word-callout {
  text-decoration: underline;
}

.relative-emphasis {
  text-transform: uppercase;
}

.content-emphasis {
  font-weight: bold;
  color: red;
}

span.passage-title:before {
  content: open-quote;
}

span.passage-title:after {
  content: close-quote;
}

.proper-name {
  font-style: italic;
}

.variable {
  font-style: italic;
}

.equation-block {
  text-align: center;
  margin-left: 20%;
  margin-right: 20%;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 60%;
  padding: 2px;
  display: block;
}

.embedded-error {
  font-style: italic;
}

/* PASSAGES */

div.passage-title,
div.passage-subtitle {
  font-weight: bold;
  text-align: center;
}

div.passage-author {
  text-align: center;
}

.p-number {
  float: left;
  font-size: 0.85em;
}

.numbered-paragraph {
  margin-left: 36px;
}

/* ch5680 - also temporary kds content styles that need to be externalized */
/* Inspect Styles */

@media print {
  .kds-noprint {
    display: none;
  }

  .noprint {
    display: none;
  }
}

.kds-absolute {
  border-left: 1px solid black;
  border-right: 1px solid black;
  padding: 0px 0.3em 0px 0.3em;
}

.abs {
  border-left: #000000 1px solid;
  border-right: #000000 1px solid;
  padding: 0px 0.3em 0px 0.3em;
}

.kds-border-1 {
  border: 1px solid black;
}

.kds-border-2 {
  border: 2px solid black;
}

.kds-center {
  margin: 0px;
  text-align: center;
}

.center {
  text-align: center;
  margin: 0;
}

.kds-exponent {
  font-size: 85%;
  margin-left: -0.4em;
  position: relative;
  top: -1.4em;
}

sup.frac {
  position: relative;
  top: -1.4em;
  font-size: 70%;
  margin-left: -0.4em;
}

.kds-fillin {
  border: 1px solid black;
  display: inline-block;
  margin: 0em 0.2em;
  padding-left: 1em;
}

.fillin {
  margin: 0em 0.2em;
  padding-left: 1em;
  border: #000000 1px solid;
  display: inline-block;
  *display: inline;
}

.kds-font-larger {
  font-size: larger;
}

.kds-font-smaller {
  font-size: smaller;
}

table.kds-fraction {
  border: 0px;
  display: inline-block;
  font-size: 85%;
  margin: 0px;
  padding: 0px;
  vertical-align: middle;
}

table.kds-fraction > tbody > tr > td.kds-numerator {
  border-bottom: 1px solid black;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  text-align: center;
}

table.kds-fraction > tbody > tr > td.kds-denominator {
  border: 0px;
  text-align: center;
}

table.frac {
  display: inline-block;
  *display: inline;
  vertical-align: middle;
  font-size: 85%;
  border: 0px;
  margin: 0px;
  padding: 0px;
}

.frac .nu {
  border-left: 0px;
  border-top: 0px;
  border-right: 0px;
  border-bottom: #000000 1px solid;
  text-align: center;
}

.frac .de {
  border: 0px;
  text-align: center;
}

.kds-hanging-indent {
  margin: 0px;
  padding-left: 3em;
  text-indent: -3em;
}

.kds-image-caption {
  font-family: Verdana, Arial, sans-serif;
  text-align: center;
}

.kds-image-left {
  float: left;
  margin-right: 5px;
}

.kds-image-right {
  float: right;
  margin-left: 5px;
}

.kds-indent {
  text-indent: 3em;
}

.indent {
  text-indent: 3em;
}

.kds-nowrap {
  display: inline-block;
  white-space: nowrap;
}

.kds-overline {
  text-decoration: overline;
}

.kds-parentheses {
  font-family: "Arial Narrow", Arial, sans-serif;
  font-size: 300%;
  font-weight: normal;
  position: relative;
  top: 8px;
}

b.frac {
  font-weight: normal;
  font-size: 300%;
  font-family: arial narrow;
  position: relative;
  top: +8px;
}

.kds-pi {
  font-family: "Times New Roman", serif;
  font-size: 1.2em;
}

.newradical {
  border-collapse: collapse;
  display: inline-block;
  *display: inline;
  vertical-align: middle;
}

.newradical td {
  border: 0px;
  padding: 0px;
  vertical-align: top;
}

.newradical td.vinculum {
  border-top: 1px solid black;
  padding: 0px;
  vertical-align: top;
}

.newradical div.exp {
  font-size: 0.7em;
  position: relative;
  left: 7px;
  bottom: 5px;
}

.kds-underline {
  text-decoration: underline;
}

.under {
  text-decoration: underline;
}

.kds-verdana2t {
  border: 1px solid white;
  text-align: left;
  text-decoration: none;
  vertical-align: top;
}

.Verdana2t {
  vertical-align: top;
  text-align: left;
  text-decoration: none;
  border: 1px solid white;
}

.kds-whole-number {
  display: inline-block;
  font-size: 120%;
  margin: 0em 0em 0em 0.2em;
}

.whole {
  display: inline-block;
  *display: inline;
  margin: 0em 0em 0em 0.2em;
  font-size: 120%;
}

table.KdsTable01 {
  border: 1px solid black;
  border-collapse: collapse;
  border-spacing: 0px;
}

table.KdsTable01 > tbody > tr > th {
  background-color: #d3d3d3;
  border: 1px solid black;
  font-weight: normal;
  padding: 2px;
  text-align: center;
}

table.KdsTable01 > tbody > tr > th.bold {
  background-color: #d3d3d3;
  border: 1px solid black;
  font-weight: bold;
  padding: 2px;
  text-align: center;
}

table.KdsTable01 > tbody > tr > td {
  border: 1px solid black;
  padding: 2px;
  text-align: center;
}

table.KdsTable01 > tbody > tr > td.bold {
  border: 1px solid black;
  font-weight: bold;
  padding: 2px;
  text-align: center;
}

table.KdsTable02 {
  border: 1px solid black;
  border-collapse: collapse;
  border-spacing: 0px;
}

table.KdsTable02 > tbody > tr > th {
  background-color: #d3d3d3;
  border: 1px solid black;
  font-weight: normal;
  padding: 2px;
}

table.KdsTable02 > tbody > tr > td {
  border: 1px solid black;
  padding: 2px;
}

.table {
  width: 100%;
  margin-bottom: 1em;
  background-color: transparent;
  border-collapse: collapse;
}

.table th, .table td {
  padding: .75em;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}

.table tbody + tbody {
  border-top: 2px solid #dee2e6;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}

th {
  text-align: inherit;
}

.table-bordered, .table-bordered th, .table-bordered td {
  border: 1px solid #dee2e6;
}

.table-bordered thead td, .table-bordered thead th {
  border-bottom-width: 2px;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}

.text-center {
  text-align: center !important;
}

.h5, h5 {
  font-size: 1.25em;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
}

.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
  margin-bottom: .5em;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.2;
  color: inherit;
}

/* LEARNOSITY OVERRIDES */
.lrn_feature h3 {
  margin-top: 0 !important;
}

/* PIE OVERRIDES */

#stimulus {
  width: 50%;
  float: left;
}

#item {
  width: 50%;
  float: left;
}

.lrn_width_auto.table {
  width: auto;
}

.TEX-S3 {
  font-family: MJXZERO, MJXTEX-S3 !important;
}

.TEX-S2 {
  font-family: MJXZERO, MJXTEX-S2 !important;
}

.TEX-S1 {
  font-family: MJXZERO, MJXTEX-S1 !important;
}

.TEX-I {
  font-family: MJXZERO, MJXTEX-I !important;
}

mjx-c.mjx-c2032 {
  font-family: 'CerebriSans', serif !important;
}

mjx-c.mjx-c22, mjx-c.mjx-c27 {
  font-family: MJXZERO, serif !important
}

table {
  border-collapse: collapse;
}

.evaluate-bottom-border > :first-child::after {
  content: '';
  display: block;
  border-bottom: 1px solid #d3d3d3;
}
